<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="card-header p-0 border-bottom-0">
                        <tab-header/>
                    </div>
                    <div class="card-body">
                        <div class="tab-content">
                            <template v-if="user_type =='0'">
                                <student-detail-tab/>
                                <application-tab :show_application="show_application" :hasMessage="hasMessage" :start_date="start_date" :end_date="end_date"/>
                                <gov-scholarship-details/>
                            </template>
                            <gov-scholarship v-else-if="user_type =='1'" :start_date="start_date" :end_date="end_date"/>
                            
                            <template v-else-if="user_type =='2'">
                                <admit-students-by-deo />
                                <admission-detail-tab-deo/>
                            </template>
                            <template v-else-if="user_type =='3'">
                                <admission-detail-tab/>
                                <admit-students-by-deo />
                            </template>
                            <template v-else-if="user_type =='4'">
                                <admit-students />
                                <admission-detail-tab-school/>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TabHeader from './tab_header.vue'
import AdmitStudents from './admit_students.vue'
import ApplicationTab from './application_tab.vue'
import GovScholarship from './gov_sholarship_tab.vue'
import GovScholarshipDetail from './gov_sholarship_detail_tab.vue'
import OnlineAdmissionDetailTab from './online_admission_detail_tab.vue'
import AdmitStudentsByDeo from './admit_students_by_deo.vue'
import AdmissionDetailTabSchool from './admission_detail_tab_school.vue'
import AdmissionDetailTab from './admission_detail_tab.vue'
import StudentBasicDetail from './student_detail_tab.vue'
import AdmissionDetailTabDeo from './admission_detail_tab_deo.vue'
export default {
    components:{
        'tab-header':TabHeader,
        'admit-students':AdmitStudents,
        'gov-scholarship':GovScholarship,
        'gov-scholarship-details':GovScholarshipDetail,
        'application-tab':ApplicationTab,
        'admission-detail-tab':AdmissionDetailTab,
        'admit-students-by-deo':AdmitStudentsByDeo,
        'online-admission-detail-tab':OnlineAdmissionDetailTab,
        'admission-detail-tab-school':AdmissionDetailTabSchool,
        'student-detail-tab':StudentBasicDetail,
        'admission-detail-tab-deo': AdmissionDetailTabDeo

    },
    data(){
        return{
            user_type:'',
            start_date:'',
            end_date:'',
            show_application: false,
            hasMessage:1
        }
    },
    methods:{
      getTimeSetting(){
          axios.get('admissions/getSetting')
            .then(response =>{ 
               let data = response.data 
               data.forEach(item => {
                    if(item.type == 'admission'){
                        let rightnow = new Date(item.rightnow);
                        let start_time = new Date(item.start_time);
                        let end_time = new Date(item.end_time);
                        this.start_date = item.start_date_formate;
                        this.end_date = item.end_date_formate;
                        if(rightnow > start_time && rightnow < end_time){
                            this.show_application = true;
                            this.hasMessage = 0;
                        }else if(rightnow < start_time){
                            this.show_application = false;
                            this.hasMessage = 1;
                        }else{
                            this.show_application = false;
                            this.hasMessage = 2;
                        }
                    }
                    if(item.type == 'admission'){
                        this.start_date = item.start_date_formate;
                        this.end_date = item.end_date_formate;
                    }
                   
               });
            })
            .catch(error => console.log(error));
      }
    },
    mounted() {
      axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
        })
        .catch(errors => {
            console.log(errors)
        });
        this.getTimeSetting()
    },
}
</script>
